import ApiService from "./api.service";
import { BASE_URL, routes } from "./routes";
/**
 * @param {object} payloadData
 * @param {string} payloadData.newPassword
 * @param {string} payloadData.passwordResetToken
 */
export async function resetPassword(payloadData) {
  const url = `${BASE_URL}/${routes.RESET_PASSWORD}`;
  try {
    const payload = {
      newPassword: payloadData.newPassword,
      passwordResetToken: payloadData.passwordResetToken,
    };
    const response = await ApiService.putApi(url, payload);

    return response.data.data;
  } catch (error) {
    const message = error?.data?.message || "Server error";
    throw message;
  }
}
